import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="footer" id="footer-id">
        <div className="footer_line"></div>
        <h3>Email me</h3>
        <h3>poptanidhara71@gmail.com</h3>
      </div>
    </div>
  );
};

export default Footer;
